import { useOrderContext } from "app/providers/OrderProvider";
import { REACT_APP_BASE_URL } from "shared/config";
import { ButtonTypes } from "shared/ui/button";
import { concatClassnames } from "shared/utils/concatClassnames";
import StatusSupportCard from "widgets/status-support-card";

interface StatusSupportProps {
  showTryPaymentAgainCard?: boolean;
}

const StatusSupport = ({
  showTryPaymentAgainCard = false,
}: StatusSupportProps) => {
  const { order } = useOrderContext();

  const onTryPaymentAgainClick = () => {
    if (!order) return;
    window.location.href = "/betalen/?orderId=" + order.id;
  };

  const onSeeQuestionsClick = () => {
    window.location.href = `${REACT_APP_BASE_URL}/faq`;
  };

  const onCustomerServiceClick = () => {
    window.location.href = `${REACT_APP_BASE_URL}/contact`;
  };

  return (
    <div
      className={concatClassnames(
        "gg-grid gg-gap-y-5 gg-items-start gg-gap-x-12",
        showTryPaymentAgainCard ? "lg:gg-flex" : "md:gg-flex"
      )}
    >
      {!showTryPaymentAgainCard ? (
        <StatusSupportCard
          title="Vragen?"
          description="Bekijk onze veelgestelde vragen, deze beantwoorden misschien je vraag!"
          buttonTitle="Veelgestelde vragen"
          buttonAction={() => onSeeQuestionsClick()}
          buttonType={ButtonTypes.DARK_BLUE}
        />
      ) : (
        <StatusSupportCard
          title="Probeer de betaling opnieuw"
          description={`Probeer de betaling opnieuw, je wordt nogmaals naar onze betaalomgeving gebracht om het te proberen. 
            Gaat het nogmaals mis, probeer dan een andere optie.`}
          buttonTitle="Opnieuw proberen"
          buttonAction={() => onTryPaymentAgainClick()}
          buttonType={ButtonTypes.YELLOW}
        />
      )}

      <StatusSupportCard
        title="Nog steeds een vraag?"
        description="Onze klantenservice zit voor je klaar om je prangende vragen te beantwoorden."
        buttonTitle="Klantenservice"
        buttonAction={() => onCustomerServiceClick()}
        buttonType={ButtonTypes.DARK_BLUE}
      />
    </div>
  );
};
export default StatusSupport;
